import React, {useState, useCallback, memo } from 'react';
import {    
            Accordion,
            AccordionDetails,
            AccordionSummary,
            Avatar,
            Button,
            Chip,
            Dialog,
            DialogActions,
            DialogTitle, 
            Divider,
            Grid,
            IconButton,
            LinearProgress,
            MenuItem,
            Paper,
            TextField,
            Typography 
        } from '@material-ui/core';
import { 
    AccountBalance as AccountBalanceIcon,
    AddCircleOutline as AddCircleOutlineIcon,
    Cached as CachedIcon,
    Delete as DeleteIcon,
    Done as DoneIcon,
    Drafts as DraftsIcon,
    ExpandMore as ExpandMoreIcon,
    ImportantDevices as ImportantDevicesIcon,
    LabelImportant as LabelImportantIcon,
    MarkunreadMailbox as MarkunreadMailboxIcon,
    Palette as PaletteIcon,
    Wallpaper as WallpaperIcon,
} from '@material-ui/icons';
import { SnackbarProvider, useSnackbar } from 'notistack';
import  FacebookCircularProgress  from '../../Elementos/FacebookCircularProgress';
import { v4 as uuidv4 } from 'uuid'; 
import { useAuth } from "../../Auth";
import { makeStyles } from '@material-ui/core/styles';
import { 
    Switch as SwitchAntd, 
    Tooltip as TooltipAntd, 
} from 'antd';
import Alert from '@material-ui/lab/Alert';
import ImageUploading from 'react-images-uploading';

const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
    },
    secondaryHeading: {
      marginTop:6,
      marginLeft:5,
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
    },
}));

const RegistrarEquipo = ({data, handleProcess })=>{
    const { enqueueSnackbar } = useSnackbar();
    const classes = useStyles();
    const { authTokens } = useAuth(); 
    const [ isProcessing, setProcessing ] = useState(false);
    const [ openDialog, setOpenDialog ] = useState(false);
    const [ Datos, setDatos ] = useState({ 
        Direccion:'',
        EmailAdministrador:'',
        EmailFactura:'',
        EmailHost:'',
        EmailNotificaciones:'',
        EmailSoporte:'',
        EmailSSL:false,
        Empresa:'',
        Ruc:'',
        Telefono:''
    });
    const [ expanded, setExpanded ] = useState(false);
    const [ arrBancos, setArrBancos ] = useState([{ Banco:'', Tipo:'', Cuenta:'', idBanco:Math.floor(Math.random() * 10000000) }]);
    const [ imagesEmpresa, setImagesEmpresa ] = useState([]);
    const [ imagesFactura, setImagesFactura ] = useState([]);

    const handleDatos = (e)=>{ setDatos({...Datos, [e.target.name]:e.target.value})};

    const handleValidacion1 = ()=>{
        setOpenDialog(false);
        if(Datos.Empresa === ''){ enqueueSnackbar('Campo Empresa Vacio' , {variant:'error'}); setProcessing(false);
        }else{ if(Datos.Ruc === ''){ enqueueSnackbar('Campo RUC Vacio' , {variant:'error'}); setProcessing(false);
        }else{ if(Datos.Direccion === ''){ enqueueSnackbar('Campo Direccion Vacio' , {variant:'error'}); setProcessing(false);
        }else{ if(Datos.Telefono === ''){ enqueueSnackbar('Campo Telefono Vacio' , {variant:'error'}); setProcessing(false);
        }else{ if(Datos.PaginaWeb === ''){enqueueSnackbar('Campo PaginaWeb Vacio' , {variant:'error'}); setProcessing(false);
        }else{ if(Datos.EmailAdministrador === ''){ enqueueSnackbar('Campo EmailAdministrador Vacio' , {variant:'error'}); setProcessing(false);
        }else{ if(Datos.EmailFactura === ''){ enqueueSnackbar('Campo EmailFactura Vacio' , {variant:'error'}); setProcessing(false);
        }else{ if(Datos.EmailHost === ''){ enqueueSnackbar('Campo EmailHost Vacio' , {variant:'error'}); setProcessing(false);
        }else{ if(Datos.EmailNotificaciones === ''){ enqueueSnackbar('Campo EmailNotificaciones Vacio' , {variant:'error'}); setProcessing(false);
        }else{ if(Datos.EmailSoporte === ''){ enqueueSnackbar('Campo EmailSoporte Vacio' , {variant:'error'}); setProcessing(false);
        }else{ 
            const numEmpresa = data.filter( el => el.Empresa === Datos.Empresa );
            if(numEmpresa.length > 0){
                enqueueSnackbar('Empresa Repetida' , {variant:'error'});
                setProcessing(false);
            }else{
                handleSave();
            }
            
        }}}}}}}}}}
        
    };

    const handleSave = ()=>{
        const idImgEmpresa = `${Datos.Empresa}_EMPRESA.${imagesEmpresa.length > 0 ? imagesEmpresa[0].file.name.split('.').pop().toString() : 'jpg'}`;
        const idImgFactura = `${Datos.Empresa}_FACTURA.${imagesFactura.length > 0 ? imagesFactura[0].file.name.split('.').pop().toString() : 'jpg'}`;
        const objeto = {...Datos};
            objeto.urlLogo = imagesEmpresa.length > 0 ? `logos/${idImgEmpresa}` : '' ;
            objeto.urlLogoFactura = imagesFactura.length > 0 ? `logos/${idImgFactura}` : '';
            objeto.Bancos = [...arrBancos]
            objeto.UsuarioCreate = authTokens.Usuario;
            objeto.id = `${Datos.Empresa}_${uuidv4()}`;
        fetch('api/Empresas',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.status){
                console.log(result.status);
                enqueueSnackbar(result.status, {variant:'error'});
                setProcessing(false);
            }else{
                enqueueSnackbar('Empresa Guardada', {variant:'success'});
                setProcessing(false);
                handleProcess(result);
                if(imagesEmpresa.length > 0){
                    const formD = new FormData();
                    formD.append('imagen',imagesEmpresa[0].file, idImgEmpresa);
                    fetch('/Empresas/LogoEmpresa',{method:'POST',body:formD})
                    .then(response => response.json())
                    .then(result => {             
                        if(result.message){
                            setImagesEmpresa([]);
                            enqueueSnackbar('LOGO EMPRESA SUBIDO', {variant:'success'});
                        }else{
                            console.error(result.status);
                            enqueueSnackbar(result.status, {variant:'error'});
                        }
                    });
                }
                if(imagesFactura.length > 0){
                    const formD = new FormData();
                    formD.append('imagen',imagesFactura[0].file, idImgFactura);
                    fetch('/Empresas/LogoFactura',{method:'POST',body:formD})
                    .then(response => response.json())
                    .then(result => {             
                        if(result.message){
                            setImagesFactura([]);
                            enqueueSnackbar('LOGO FACTURA SUBIDO', {variant:'success'});
                        }else{
                            console.error(result.status);
                            enqueueSnackbar(result.status, {variant:'error'});
                        }
                    });
                }
                setDatos({
                    Direccion:'',
                    EmailAdministrador:'',
                    EmailFactura:'',
                    EmailHost:'',
                    EmailNotificaciones:'',
                    EmailSoporte:'',
                    EmailSSL:false,
                    Empresa:'',
                    Ruc:'',
                    Telefono:''
                });
                setArrBancos([{ Banco:'', Tipo:'', Cuenta:'', idBanco:Math.floor(Math.random() * 10000000) }]);
                
            }
        });   
    };
    
    const handleAlert = ()=>{
        if(!isProcessing){
            setOpenDialog(true);
            setProcessing(true);
        }
    };

    const handleAlertClose = ()=>{
        setOpenDialog(false);
        setProcessing(false);
    };

    const handleChange = (panel) => (event, isExpanded) => { setExpanded( isExpanded ? panel : false ); };

    const handleSwitchSSL = (checked)=>{ setDatos({...Datos, EmailSSL:checked})};

    const handleBancos = useCallback((idBanco, elBanco)=>{
        const arrS = [...arrBancos];
        const arr = arrS.map(value=>{
            const objeto = {...value}
            if(value.id === idBanco){
                return elBanco;
            }else{
                return objeto;
            }
        });
        setArrBancos(arr);
    },[arrBancos]);

    const handleCrearBanco = useCallback(()=>{
        setArrBancos([...arrBancos, { Banco:'', Tipo:'', Cuenta:'', idBanco:Math.floor(Math.random() * 10000000) }]);
    },[arrBancos]);
    
    const handleBorrarBanco = useCallback((id)=>{
        const arrS = [...arrBancos];
        const filSubnet = arrS.filter(value=> value.idBanco !== id);
        setArrBancos(filSubnet);
    },[arrBancos]);

    const BancoEl = arrBancos.map((value, index)=>(
        <ElementBanco 
            arrBancos={arrBancos}
            data={value} 
            handleBancos={handleBancos}
            handleCrearBanco={handleCrearBanco}
            handleBorrarBanco={handleBorrarBanco}
            idBanco={value.idBanco}  
            index={index} 
            key={value.idBanco} 
            total={arrBancos.length} 
        />
    ));

    const onChangeImageEmpresa = (imageList, addUpdateIndex) => { setImagesEmpresa(imageList); };

    const onChangeImageFactura = (imageList, addUpdateIndex) => { setImagesFactura(imageList); };

    return(
        <Grid container spacing={1} justify='center' >
            <Dialog
                open={openDialog}
                onClose={handleAlertClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Desea Guardar esta Empresa"} </DialogTitle>
                <DialogActions style={{display:'flex', justifyContent:'center'}}>
                <Button onClick={handleValidacion1} color="primary" variant='contained' style={{color:'#fff'}}>
                    Si
                </Button>
                <Button onClick={handleAlertClose} color="default" variant='contained' style={{color:'#fff'}}>
                    No
                </Button>
                </DialogActions>
            </Dialog>  
            <Grid item xs={12}>
                {isProcessing ? <LinearProgress color='secondary' /> : <div style={{height:6}}></div>}
            </Grid> 
            <Grid item md={6} xs={12} >         
                <Paper elevation={2} >
                    <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')} >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                        >
                            < Chip 
                                avatar={<Avatar><ImportantDevicesIcon fontSize='small'/></Avatar>}
                                color='primary'
                                label='Informacion General'  
                            />
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container direction="row" justifyContent="center" alignItems="flex-start" spacing={2} style={{ alignContent:'flex-start', padding:10}}>
                                <Grid item sm={6} xs={12}>
                                    <TextField
                                        value={Datos.Empresa || ''}
                                        name='Empresa'
                                        onChange={handleDatos}
                                        label='Empresa'
                                        fullWidth
                                        size='small'
                                        variant='outlined'                             
                                    />
                                </Grid>   
                                <Grid item sm={6} xs={12}>
                                    <TextField
                                        value={Datos.Ruc || ''}
                                        name='Ruc'
                                        onChange={handleDatos}
                                        label='RUC'
                                        fullWidth
                                        size='small'
                                        variant='outlined'                             
                                    />
                                </Grid>  
                                <Grid item sm={6} xs={12}>
                                    <TextField
                                        value={Datos.Telefono || ''}
                                        name='Telefono'
                                        onChange={handleDatos}
                                        label='Telefono'
                                        fullWidth
                                        size='small'
                                        variant='outlined'                             
                                    />
                                </Grid>     
                                <Grid item sm={6} xs={12}>
                                    <TextField
                                        value={Datos.PaginaWeb || ''}
                                        name='PaginaWeb'
                                        onChange={handleDatos}
                                        label='PaginaWeb'
                                        fullWidth
                                        size='small'
                                        variant='outlined'                             
                                    />
                                </Grid> 
                                <Grid item sm={6} xs={12}>
                                    <TextField
                                        value={Datos.Direccion || ''}
                                        name='Direccion'
                                        onChange={handleDatos}
                                        label='Direccion'
                                        fullWidth
                                        size='small'
                                        variant='outlined'                             
                                    />
                                </Grid> 
                                <Grid item sm={6} xs={12}>
                                    <TextField
                                        value={Datos.Coordenadas || ''}
                                        name='Coordenadas'
                                        onChange={handleDatos}
                                        label='Coordenadas'
                                        fullWidth
                                        size='small'
                                        variant='outlined'                             
                                    />
                                </Grid> 
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2bh-content"
                        id="panel2bh-header"
                        >
                            < Chip 
                                avatar={<Avatar><MarkunreadMailboxIcon fontSize='small'/></Avatar>}
                                color='primary'
                                label='Correos'  
                            />
                            <Typography className={classes.secondaryHeading}>Credenciales</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container direction="row" justifyContent="center" alignItems="flex-start" spacing={2} style={{ alignContent:'flex-start', padding:10}}>
                                <Grid item sm={6} xs={12}>
                                    <TextField
                                        value={Datos.EmailAdministrador || ''}
                                        name='EmailAdministrador'
                                        onChange={handleDatos}
                                        label='EmailAdministrador'
                                        fullWidth
                                        size='small'
                                        variant='outlined'                             
                                    />
                                </Grid> 
                                <Grid item sm={6} xs={12}>
                                    <TextField
                                        value={Datos.EmailHost || ''}
                                        name='EmailHost'
                                        onChange={handleDatos}
                                        label='EmailHost'
                                        fullWidth
                                        size='small'
                                        variant='outlined'                             
                                    />
                                </Grid> 
                                <Grid item sm={6} xs={12}>
                                    <TextField
                                        value={Datos.EmailPuerto || ''}
                                        name='EmailPuerto'
                                        onChange={handleDatos}
                                        label='EmailPuerto'
                                        fullWidth
                                        size='small'
                                        variant='outlined'   
                                        type='Number'                          
                                    />
                                </Grid> 
                                <Grid item sm={6} xs={12} style={{display:'flex', justifyContent:'center', alignItems:'center', height:55 }}>
                                    <TooltipAntd title="SSL" color='BLUE' >
                                        <SwitchAntd checkedChildren="SSL ON" unCheckedChildren="SSL OFF" checked={Datos.EmailSSL} onChange={handleSwitchSSL} />
                                    </TooltipAntd>  
                                </Grid> 
                                <Grid item sm={6} xs={12}>
                                    <TextField
                                        value={Datos.EmailBackups || ''}
                                        name='EmailBackups'
                                        onChange={handleDatos}
                                        label='Email Backups'
                                        fullWidth
                                        size='small'
                                        variant='outlined'                             
                                    />
                                </Grid>
                                <Grid item sm={6} xs={12}>
                                    <TextField
                                        value={Datos.PassBackups || ''}
                                        name='PassBackups'
                                        onChange={handleDatos}
                                        label='Pass Backups'
                                        fullWidth
                                        size='small'
                                        variant='outlined'                             
                                    />
                                </Grid>  
                                <Grid item sm={6} xs={12}>
                                    <TextField
                                        value={Datos.EmailFactura || ''}
                                        name='EmailFactura'
                                        onChange={handleDatos}
                                        label='EmailFactura'
                                        fullWidth
                                        size='small'
                                        variant='outlined'                             
                                    />
                                </Grid>
                                <Grid item sm={6} xs={12}>
                                    <TextField
                                        value={Datos.PassFactura || ''}
                                        name='PassFactura'
                                        onChange={handleDatos}
                                        label='PassFactura'
                                        fullWidth
                                        size='small'
                                        variant='outlined'                             
                                    />
                                </Grid>  
                                <Grid item sm={6} xs={12}>
                                    <TextField
                                        value={Datos.EmailNotificaciones || ''}
                                        name='EmailNotificaciones'
                                        onChange={handleDatos}
                                        label='EmailNotificaciones'
                                        fullWidth
                                        size='small'
                                        variant='outlined'                             
                                    />
                                </Grid>
                                <Grid item sm={6} xs={12}>
                                    <TextField
                                        value={Datos.PassNotificaciones || ''}
                                        name='PassNotificaciones'
                                        onChange={handleDatos}
                                        label='PassNotificaciones'
                                        fullWidth
                                        size='small'
                                        variant='outlined'                             
                                    />
                                </Grid> 
                                <Grid item sm={6} xs={12}>
                                    <TextField
                                        value={Datos.EmailPagos || ''}
                                        name='EmailPagos'
                                        onChange={handleDatos}
                                        label='EmailPagos'
                                        fullWidth
                                        size='small'
                                        variant='outlined'                             
                                    />
                                </Grid>
                                <Grid item sm={6} xs={12}>
                                    <TextField
                                        value={Datos.PassPagos || ''}
                                        name='PassPagos'
                                        onChange={handleDatos}
                                        label='PassPagos'
                                        fullWidth
                                        size='small'
                                        variant='outlined'                             
                                    />
                                </Grid> 
                                <Grid item sm={6} xs={12}>
                                    <TextField
                                        value={Datos.EmailInfo || ''}
                                        name='EmailInfo'
                                        onChange={handleDatos}
                                        label='EmailInfo'
                                        fullWidth
                                        size='small'
                                        variant='outlined'                             
                                    />
                                </Grid>
                                <Grid item sm={6} xs={12}>
                                    <TextField
                                        value={Datos.PassInfo || ''}
                                        name='PassInfo'
                                        onChange={handleDatos}
                                        label='PassInfo'
                                        fullWidth
                                        size='small'
                                        variant='outlined'                             
                                    />
                                </Grid> 
                                <Grid item sm={6} xs={12}>
                                    <TextField
                                        value={Datos.EmailProformas || ''}
                                        name='EmailProformas'
                                        onChange={handleDatos}
                                        label='EmailProformas'
                                        fullWidth
                                        size='small'
                                        variant='outlined'                             
                                    />
                                </Grid>
                                <Grid item sm={6} xs={12}>
                                    <TextField
                                        value={Datos.PassProformas || ''}
                                        name='PassProformas'
                                        onChange={handleDatos}
                                        label='PassProformas'
                                        fullWidth
                                        size='small'
                                        variant='outlined'                             
                                    />
                                </Grid> 
                                <Grid item sm={6} xs={12}>
                                    <TextField
                                        value={Datos.EmailSoporte || ''}
                                        name='EmailSoporte'
                                        onChange={handleDatos}
                                        label='EmailSoporte'
                                        fullWidth
                                        size='small'
                                        variant='outlined'                             
                                    />
                                </Grid>
                                <Grid item sm={6} xs={12}>
                                    <TextField
                                        value={Datos.PassSoporte || ''}
                                        name='PassSoporte'
                                        onChange={handleDatos}
                                        label='PassSoporte'
                                        fullWidth
                                        size='small'
                                        variant='outlined'                             
                                    />
                                </Grid> 
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel3bh-content"
                        id="panel3bh-header"
                        >
                            < Chip 
                                avatar={<Avatar><LabelImportantIcon fontSize='small'/></Avatar>}
                                color='primary'
                                label='Twilio'  
                            />
                            <Typography className={classes.secondaryHeading}>Envio de SMS</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container direction="row" justifyContent="center" alignItems="flex-start" spacing={2} style={{ alignContent:'flex-start', padding:10}}>
                                <Grid item sm={6} xs={12}>
                                    <TextField
                                        value={Datos.TwilioSID || ''}
                                        name='TwilioSID'
                                        onChange={handleDatos}
                                        label='TwilioSID'
                                        fullWidth
                                        size='small'
                                        variant='outlined'                             
                                    />
                                </Grid> 
                                <Grid item sm={6} xs={12}>
                                    <TextField
                                        value={Datos.TwilioTOKEN || ''}
                                        name='TwilioTOKEN'
                                        onChange={handleDatos}
                                        label='TwilioTOKEN'
                                        fullWidth
                                        size='small'
                                        variant='outlined'                             
                                    />
                                </Grid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel4bh-content"
                        id="panel4bh-header"
                        >
                            < Chip 
                                avatar={<Avatar><PaletteIcon fontSize='small'/></Avatar>}
                                color='primary'
                                label='Colores'  
                            />
                        <Typography className={classes.secondaryHeading}>Colores en Hexadecimal</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container direction="row" justifyContent="center" alignItems="flex-start" spacing={2} style={{ alignContent:'flex-start', padding:10}}>
                                <Grid item sm={6} xs={12}>
                                    <TextField
                                        value={Datos.ColorPrimary || ''}
                                        name='ColorPrimary'
                                        onChange={handleDatos}
                                        label='ColorPrimary'
                                        fullWidth
                                        size='small'
                                        variant='outlined'                             
                                    />
                                </Grid> 
                                <Grid item sm={6} xs={12}>
                                    <TextField
                                        value={Datos.ColorSecondary || ''}
                                        name='ColorSecondary'
                                        onChange={handleDatos}
                                        label='ColorSecondary'
                                        fullWidth
                                        size='small'
                                        variant='outlined'                             
                                    />
                                </Grid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion> 
                    <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel5bh-content"
                        id="panel5bh-header"
                        >
                            < Chip 
                                avatar={<Avatar><WallpaperIcon fontSize='small'/></Avatar>}
                                color='primary'
                                label='Logos'  
                            />
                        <Typography className={classes.secondaryHeading}>Logos de Empresa</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container direction="row" justifyContent="center" alignItems="flex-start" spacing={2} style={{ alignContent:'flex-start', padding:10}}>
                                <Grid item sm={6} xs={12}>
                                    <div className="App">
                                        <ImageUploading
                                            multiple
                                            value={imagesEmpresa}
                                            onChange={onChangeImageEmpresa}
                                            maxNumber={1}
                                            dataURLKey="data_url"
                                        >
                                            {({
                                            imageList,
                                            onImageUpload,
                                            onImageRemoveAll,
                                            onImageUpdate,
                                            onImageRemove,
                                            isDragging,
                                            dragProps,
                                            }) => (
                                            // write your building UI
                                            <Grid container justifyContent='center' spacing={2}>
                                                <Grid item xs={5}>
                                                    < Chip 
                                                        color='default'
                                                        label='LOGO EMPRESA'  
                                                    />
                                                </Grid>
                                                <Grid item xs={9}>
                                                    <Button 
                                                        variant="contained" 
                                                        color="secondary"
                                                        fullWidth
                                                        size='large'
                                                        style={isDragging ? { color: 'red' } : undefined}
                                                        onClick={onImageUpload}
                                                        {...dragProps}
                                                    >
                                                        Click or Drop here
                                                    </Button>
                                                </Grid>
                                                <Grid item xs={9}>
                                                    {imageList.map((image, index) => (
                                                        <Grid container alignItems='center' justifyContent='center' key={index} direction='column'>
                                                            <Grid item>
                                                                <img src={image['data_url']} alt="" width="100" />
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <Grid container justifyContent='center'>
                                                                    <Grid item>
                                                                        <IconButton
                                                                            onClick={() => onImageUpdate(index)}
                                                                            size='small'
                                                                            color='secondary'
                                                                            style={{color:"green"}}
                                                                        >
                                                                            <CachedIcon/>
                                                                        </IconButton>
                                                                    </Grid>
                                                                    <Grid item>
                                                                        <IconButton
                                                                            onClick={() => onImageRemove(index)}
                                                                            size='small'
                                                                            color='secondary'
                                                                            style={{color:"red"}}
                                                                        >
                                                                            <DeleteIcon/>
                                                                        </IconButton>
                                                                    </Grid>
                                                                </Grid>                                                             
                                                            </Grid>
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                            </Grid>
                                            )}
                                        </ImageUploading>
                                    </div>
                                </Grid>
                                <Grid item sm={6} xs={12}>
                                    <div className="App">
                                        <ImageUploading
                                            multiple
                                            value={imagesFactura}
                                            onChange={onChangeImageFactura}
                                            maxNumber={1}
                                            dataURLKey="data_url"
                                        >
                                            {({
                                            imageList,
                                            onImageUpload,
                                            onImageRemoveAll,
                                            onImageUpdate,
                                            onImageRemove,
                                            isDragging,
                                            dragProps,
                                            }) => (
                                            // write your building UI
                                            <Grid container justifyContent='center' spacing={2}>
                                                <Grid item xs={5}>
                                                    < Chip 
                                                        color='default'
                                                        label='LOGO FACTURA'  
                                                    />
                                                </Grid>
                                                <Grid item xs={9}>
                                                    <Button 
                                                        variant="contained" 
                                                        color="secondary"
                                                        fullWidth
                                                        size='large'
                                                        style={isDragging ? { color: 'red' } : undefined}
                                                        onClick={onImageUpload}
                                                        {...dragProps}
                                                    >
                                                        Click or Drop here
                                                    </Button>
                                                </Grid>
                                                <Grid item xs={9}>
                                                    {imageList.map((image, index) => (
                                                        <Grid container alignItems='center' justifyContent='center' key={index} direction='column'>
                                                            <Grid item>
                                                                <img src={image['data_url']} alt="" width="100" />
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <Grid container justifyContent='center'>
                                                                    <Grid item>
                                                                        <IconButton
                                                                            onClick={() => onImageUpdate(index)}
                                                                            size='small'
                                                                            color='secondary'
                                                                            style={{color:"green"}}
                                                                        >
                                                                            <CachedIcon/>
                                                                        </IconButton>
                                                                    </Grid>
                                                                    <Grid item>
                                                                        <IconButton
                                                                            onClick={() => onImageRemove(index)}
                                                                            size='small'
                                                                            color='secondary'
                                                                            style={{color:"red"}}
                                                                        >
                                                                            <DeleteIcon/>
                                                                        </IconButton>
                                                                    </Grid>
                                                                </Grid>                                                             
                                                            </Grid>
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                            </Grid>
                                            )}
                                        </ImageUploading>
                                    </div>
                                </Grid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>  
                    <Accordion expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel6bh-content"
                        id="panel6bh-header"
                        >
                            < Chip 
                                avatar={<Avatar><AccountBalanceIcon fontSize='small'/></Avatar>}
                                color='primary'
                                label='Bancos'  
                            />
                        <Typography className={classes.secondaryHeading}>Cuentas Bancarias</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container direction="row" justifyContent="center" alignItems="flex-start" spacing={2} style={{ alignContent:'flex-start', padding:10}}>
                            { BancoEl }
                            </Grid>
                        </AccordionDetails>
                    </Accordion>  
                    <Accordion expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel7bh-content"
                        id="panel7bh-header"
                        >
                            < Chip 
                                avatar={<Avatar><DraftsIcon fontSize='small'/></Avatar>}
                                color='primary'
                                label='E-Mails'  
                            />
                        <Typography className={classes.secondaryHeading}>Plantillas de E-mails</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container direction="row" justifyContent="center" alignItems="flex-start" spacing={2} style={{ alignContent:'flex-start', padding:10}}>
                                <Grid item xs={12}>
                                    <TextField
                                        value={Datos.EmailBienvenida || ''}
                                        name='EmailBienvenida'
                                        onChange={handleDatos}
                                        label='Correo de Bienvenida'
                                        fullWidth
                                        variant='outlined' 
                                        multiline        
                                        maxRows={10}                      
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Divider />
                                </Grid>
                                <Grid item xs={12}>
                                <Alert severity="info">1:Nombres de Cliente = ${`{Nombres}`} || 2:Mes = ${`{MesServicio}`}</Alert>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        value={Datos.EmailPagosPlantilla || ''}
                                        name='EmailPagosPlantilla'
                                        onChange={handleDatos}
                                        label='Correo de Pagos'
                                        fullWidth
                                        variant='outlined' 
                                        multiline     
                                        maxRows={10}                       
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Divider />
                                </Grid>
                                <Grid item xs={12}>
                                    <Alert severity="info">Nombres de Cliente = ${`{Nombres}`}</Alert>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        value={Datos.EmailInstalacionesPagadas || ''}
                                        name='EmailInstalacionesPagadas'
                                        onChange={handleDatos}
                                        label='Instalacion Pagada Completa'
                                        fullWidth
                                        variant='outlined' 
                                        multiline     
                                        maxRows={10}                       
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Divider />
                                </Grid>
                                <Grid item xs={12}>
                                    <Alert severity="info">1:Nombres de Cliente = ${`{Nombres}`} || 2:Valor de Abono = ${`{ValAbono}`}</Alert>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        value={Datos.EmailInstalacionesAbonadas || ''}
                                        name='EmailInstalacionesAbonadas'
                                        onChange={handleDatos}
                                        label='Abono de Instalacion'
                                        fullWidth
                                        variant='outlined' 
                                        multiline     
                                        maxRows={10}                       
                                    />
                                </Grid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>                 
                </Paper>   
            </Grid>
            <Grid item xs={12}>
                <Grid container justifyContent='center'>
                    <Grid item md={3} sm={5} xs={12}>
                        <Button onClick={handleAlert} variant='contained'  fullWidth color='primary' size='large'  endIcon={<DoneIcon />} disabled={isProcessing}>
                            {isProcessing ? <FacebookCircularProgress size={12} style={{marginTop:5}}/> : 'Guardar'}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>  
        </Grid>
       
    );
};

const ElementBanco = memo((props)=>{
    const { index, total, idBanco, handleBorrarBanco, handleCrearBanco, arrBancos, handleBancos } = props;
    const [ Datos, setDatos ] = useState({Banco:'', Tipo:'', Cuenta:'', idBanco});
    let cantItem = index + 1;
  
    const handleSubBorrarBanco = ()=>{ handleBorrarBanco(idBanco); };

    const handleDatos = ({target})=>{ setDatos({...Datos, [target.id]:target.value}); };

    const handleDatosSelect = ({target})=>{ setDatos({...Datos, Tipo:target.value}); };

    const handleSubSubnetBanco = ({target})=>{
        const objeto = {...Datos};
        objeto.Banco = target.value;
        handleBancos(idBanco, objeto);
    };

    const handleSubSubnetTipo = ({target})=>{
        const objeto = {...Datos};
        objeto.Tipo = target.value;
        handleBancos(idBanco, objeto);
    };

    const handleSubSubnetCuenta = ({target})=>{
        const objeto = {...Datos};
        objeto.Cuenta = target.value;
        handleBancos(idBanco, objeto);
    };

    if(arrBancos.length === 1){
        return(
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} >  
                <Paper elevation={2} style={{padding:10}} square >
                    <Grid container justifyContent='flex-start' spacing={2}>
                        <Grid item  md={8} xs={12}>
                            <TextField
                                value={Datos.Banco || ''}
                                id='Banco'
                                onChange={handleDatos}
                                label='Banco'
                                fullWidth
                                size='small'
                                variant='outlined'  
                                onBlur={handleSubSubnetBanco}                           
                            />
                        </Grid>  
                        <Grid item md={4} xs={12}>
                            <TextField
                                value={Datos.Tipo || ''}
                                id='Tipo'
                                onChange={handleDatosSelect}
                                label='Tipo'
                                fullWidth
                                size='small'
                                variant='outlined'   
                                onBlur={handleSubSubnetTipo}      
                                select                     
                            >
                                <MenuItem value='Ahorros'>Ahorros</MenuItem>
                                <MenuItem value='Corriente'>Corriente</MenuItem>
                            </TextField>
                        </Grid>    
                        <Grid item md={8} xs={10}>
                            <TextField
                                value={Datos.Cuenta || ''}
                                id='Cuenta'
                                onChange={handleDatos}
                                label='Cuenta'
                                fullWidth
                                size='small'
                                variant='outlined'   
                                onBlur={handleSubSubnetCuenta}                           
                            />
                        </Grid>                 
                        <Grid item xs={2}>
                            <IconButton onClick={handleCrearBanco} style={{position:'relative', top:-3, left:-12}}>
                                <AddCircleOutlineIcon color='primary'/>
                            </IconButton>
                        </Grid>
                    </Grid>         
                </Paper>
            </Grid>             
        );
    }else{
        return(         
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <Paper elevation={2} style={{padding:10}} square>
                    <Grid container justifyContent='flex-start' spacing={2} >
                        <Grid item md={8} xs={12} >
                            <TextField
                                value={Datos.Banco || ''}
                                id='Banco'
                                onChange={handleDatos}
                                label='Banco'
                                fullWidth
                                size='small'
                                variant='outlined'  
                                onBlur={handleSubSubnetBanco}                           
                            />
                        </Grid>  
                        <Grid item md={4} xs={12} >
                        <TextField
                                value={Datos.Tipo || ''}
                                id='Tipo'
                                onChange={handleDatosSelect}
                                label='Tipo'
                                fullWidth
                                size='small'
                                variant='outlined'   
                                onBlur={handleSubSubnetTipo}      
                                select                     
                            >
                                <MenuItem value='Ahorros'>Ahorros</MenuItem>
                                <MenuItem value='Corriente'>Corriente</MenuItem>
                            </TextField>
                        </Grid>    
                        <Grid item md={8} xs={10} >
                            <TextField
                                value={Datos.Cuenta || ''}
                                id='Cuenta'
                                onChange={handleDatos}
                                label='Cuenta'
                                fullWidth
                                size='small'
                                variant='outlined'   
                                onBlur={handleSubSubnetCuenta}                           
                            />
                        </Grid>    
                        <Grid item xs={2}>
                            { cantItem === total && 
                            <React.Fragment >
                                <IconButton onClick={handleCrearBanco} size='small' style={{position:'relative', top:5}}      >
                                    <AddCircleOutlineIcon color='primary'/>
                                </IconButton>
                                <IconButton onClick={handleSubBorrarBanco} size='small' style={{position:'relative', top:5}}      >
                                    <DeleteIcon style={{color:'red'}}/>
                                </IconButton>
                            </React.Fragment>
                            }
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>   
        );
    }
    
});


const RegistrarEquipos= ({ data, handleProcess, dataZona })=>{
    return (
        <SnackbarProvider maxSnack={3} hideIconVariant={false} dense anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}>
          <RegistrarEquipo data={data} handleProcess={handleProcess} dataZona={dataZona}/>
        </SnackbarProvider>
    );
};

export default RegistrarEquipos;